import { CalendarDays } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const monthLabel = (m) =>
  new Date(`${m}-01T00:00:00Z`).toLocaleDateString("en-US", { month: "long", year: "numeric", timeZone: "UTC" });

export const MonthTabs = ({ months, current, month, setMonth }) => (
  <Select value={month ?? current ?? ""} onValueChange={(v) => setMonth(v === current ? null : v)}>
    <SelectTrigger className="month-select w-auto justify-start" data-testid="leaderboard-month-select">
      <CalendarDays className="h-4 w-4 shrink-0 text-[#FFC700]" />
      <SelectValue placeholder="Select month" />
    </SelectTrigger>
    <SelectContent className="month-select-menu" data-testid="leaderboard-month-menu">
      {months.map((m) => (
        <SelectItem key={m} value={m} className="month-select-item" data-testid={`leaderboard-month-${m}`}>
          {monthLabel(m)}{m === current ? " · Live" : ""}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
